import { ApiError } from "./errors";

export const MUTATION_TIMEOUT_MS = 30_000;

export const UNKNOWN_OUTCOME = "El servidor no respondió a tiempo: puede haber llegado o no.";

export async function withDeadline<T>(
  run: (signal: AbortSignal) => Promise<T>,
  timeoutMs: number = MUTATION_TIMEOUT_MS,
): Promise<T> {
  const controller = new AbortController();
  let timer: ReturnType<typeof setTimeout> | undefined;
  const expired = new Promise<never>((_, reject) => {
    timer = setTimeout(() => {
      controller.abort();
      reject(new ApiError(UNKNOWN_OUTCOME, undefined, "RequestTimeout"));
    }, timeoutMs);
  });
  try {
    return await Promise.race([run(controller.signal), expired]);
  } catch (error) {
    if (controller.signal.aborted) {
      throw new ApiError(UNKNOWN_OUTCOME, undefined, "RequestTimeout");
    }
    throw error;
  } finally {
    clearTimeout(timer);
  }
}
